import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

const sizeClasses = {
  sm: 'h-5 w-5',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
} as const

interface LoadingSpinnerProps {
  variant?: 'fullscreen' | 'inline'
  label?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function LoadingSpinner({
  variant = 'inline',
  label,
  size = 'md',
  className,
}: LoadingSpinnerProps) {
  const content = (
    <div className="text-center">
      <Loader2
        className={cn(
          'animate-spin text-muted-foreground mx-auto',
          sizeClasses[size],
        )}
      />
      {label && <p className="mt-3 text-sm text-muted-foreground">{label}</p>}
    </div>
  )

  if (variant === 'fullscreen') {
    return (
      <div
        className={cn(
          'flex min-h-screen items-center justify-center',
          className,
        )}
      >
        {content}
      </div>
    )
  }

  return (
    <div className={cn('flex items-center justify-center py-12', className)}>
      {content}
    </div>
  )
}
